import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

declare var $:any;
declare var AOS:any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  
  html: SafeHtml;
  urlSafe: SafeResourceUrl;
  currentUser;
  interval_id;
  constructor(private router: Router,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    // let link = '<div class="col s12 center red-text">sd</div>';
    // this.html = this.sanitizer.bypassSecurityTrustHtml(link);
    this.urlSafe =  this.sanitizer.bypassSecurityTrustResourceUrl('./assets/otacon/index.html');
    this.interval_id = setInterval(() => {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      // console.log(this.currentUser);
      if(this.currentUser != null){
        this.router.navigate(['/user/dashboard']);
        clearInterval(this.interval_id);
      }
    }, 1000);
  }

  ngOnDestroy() {
    location.reload();
    console.log("destory");
  
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_welcome/home/home.component.ts